import { openComposeWithViewState } from './openCompose';
import createComposePlugins from '../plugins/createComposePlugins';
import { ComposeTarget } from 'owa-mail-compose-store';
import { attachmentStore } from 'owa-attachment-model-store';
import ComposePopoutData from '../store/schema/ComposePopoutData';
import { action } from 'satcheljs/lib/legacy';
import mailTipsCacheStore from 'owa-mail-tips/lib/store/store';
import { isFeatureEnabled } from 'owa-feature-flags';
import recreateNestedMruCacheFromMailTipsCacheEntries from 'owa-mail-tips/lib/utils/recreateNestedMruCacheFromMailTipsCacheEntries';
import { setBposNavBarData } from 'owa-bpos-store';
import initializeCLPStore from 'owa-mail-clp/lib/actions/initializeCLPStore';

export default action('recreateComposeFromViewState')(function recreateComposeFromViewState(
    viewState: ComposePopoutData,
    composeTargetOverride?: ComposeTarget
) {
    const { composeViewState, attachments, mailtips, clpStore, bposNavBarData } = viewState;

    // Set up plugins.
    createComposePlugins(composeViewState);

    // Set up attachments, if present.
    if (attachments) {
        attachments.forEach(model => {
            attachmentStore().attachments.set(model.id.Id, model);
        });
    }

    // Set up MailTipsCache if present
    if (mailtips) {
        const mailtipsData = recreateNestedMruCacheFromMailTipsCacheEntries(mailtips);
        mailTipsCacheStore.mailTips.initialize(mailtipsData);
    }

    if (isFeatureEnabled('cmp-clp') && clpStore) {
        initializeCLPStore(clpStore);
    }

    if (bposNavBarData) {
        setBposNavBarData(bposNavBarData);
    }

    const composeTarget =
        composeTargetOverride !== undefined ? composeTargetOverride : ComposeTarget.SecondaryTab;
    openComposeWithViewState(viewState.composeViewState, composeTarget);
});
